import Vue from 'vue'
import VueRouter from 'vue-router'
import Laptop from '@/components/Laptop'
import Freeapp from '@/components/Freeapp'
import Desktop from '@/components/Desktop'
import OSimages from '@/components/OS-images'
import themes from '@/components/Themes'
import Kext from '@/components/Kext.vue'
// import VueAnalytics from 'vue-analytics'

Vue.use(VueRouter)

const router =  new VueRouter({
	base: '/hackintosh/',
	routes: [
	{
		path: '/',
		name: 'Laptop',
		component: Laptop
	},
	{
		path: '/desktop',
		name: 'Desktop',
		component: Desktop
	},
	{
		path: '/freeapp',
		name: 'Freeapp',
		component: Freeapp
	},
	{
		path: '/OS-images',
		name: 'OSimages',
		component: OSimages
	},
	{
		path: '/themes',
		name: 'Themes',
		component: themes
	},
	{
		path: '/kext',
		name: 'Kext',
		component: Kext
	}
	]
})

// Vue.use(VueAnalytics, {
// 	id: 'UA-115909876-1',
// 	router
// })

export default router